// Core requirements for Bootstrap 3 Webpack Entry Modules
import ko from 'knockout';
import mapping from 'ko.mapping';
ko.mapping = mapping;

import 'bootstrap';

import 'hqwebapp/js/bootstrap3/common';
import 'hqwebapp/js/bootstrap3/base_main';
import 'open-chat-studio-widget';
